import { render, staticRenderFns } from "./ClipIcon.vue?vue&type=template&id=1507e2ac&scoped=true"
var script = {}
import style0 from "./ClipIcon.vue?vue&type=style&index=0&id=1507e2ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1507e2ac",
  null
  
)

export default component.exports